/**
 * Dashboard-specific type definitions.
 * Re-exports shared types and adds dashboard-only types.
 */

// Re-export shared types for convenient imports within the dashboard
export type {
  User,
  Site,
  Domain,
  DomainStatus,
  Build,
  BuildStatus,
  ApiResponse,
  PaginatedResponse,
  AuthMeResponse,
  ContentSourceType,
  CreateSiteRequest,
  CreateSiteResponse,
  AddDomainRequest,
  DomainStatusResponse,
} from '@shared/types.ts';

/** Request body for PATCH /api/sites/:id */
export interface UpdateSiteRequest {
  themeId?: string;
}

/** Response from POST /api/sites/:id/api-key */
export interface RegenerateApiKeyResponse {
  apiKey: string;
}

/** JWT token stored in localStorage. */
export interface AuthState {
  token: string | null;
  user: import('@shared/types.ts').User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
}

/** Theme option shown in the create-site form. */
export interface ThemeOption {
  id: string;
  name: string;
  description: string;
}

/** Available themes — extend as new themes are added. */
export const AVAILABLE_THEMES: ThemeOption[] = [
  {
    id: 'salon-luxe',
    name: 'Salon Luxe',
    description: 'Elegant theme for salons and spas',
  },
  {
    id: 'artist-gallery',
    name: 'Artist Gallery',
    description: 'Portfolio theme for artists and creatives',
  },
  {
    id: 'bistro-bold',
    name: 'Bistro Bold',
    description: 'Dark-mode restaurant theme with bold typography and vibrant accents',
  },
  {
    id: 'aero-transit',
    name: 'Aero Transit',
    description: 'Multi-page airport theme with flight tables, terminal map, and transport info',
  },
];
